var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-file-o'></i> Detil Pengajuan"
    }
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "is-full-page": false
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "panel panel-sm"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', [_vm._v("Upload CSV Laporan")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "csv_file",
      "name": "csv_file"
    },
    on: {
      "change": function($event) {
        _vm.upload($event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [(_vm.jns_laporan != '') ? _c('a', {
    attrs: {
      "href": _vm.$http.options.root + '/dllaporan/' + _vm.jns_laporan
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "title": "Format Laporan"
    },
    on: {
      "click": function($event) {}
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Download\n              Format")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Laporan"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.jns_laporan),
      expression: "jns_laporan"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Jenis Dokumen Yang Diajukan"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.jns_laporan = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Pilih Laporan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Laporan Tempat Penimbunan Sementara")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Laporan Bongkar Kawasan Pabean")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Laporan BKC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Rekonsiliasi Outward Manifes - Barkir")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Tanggal Awal Laporan"
    }
  }, [_c('b-form-input', {
    attrs: {
      "title": "Tanggal Permohonan Izin",
      "name": "Tgl Akhir",
      "type": "date"
    },
    model: {
      value: (_vm.tgl_awal),
      callback: function($$v) {
        _vm.tgl_awal = $$v
      },
      expression: "tgl_awal"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Tanggal Akhir Laporan"
    }
  }, [_c('b-form-input', {
    attrs: {
      "title": "Tanggal Permohonan Izin",
      "name": "Tgl Akhir",
      "type": "date"
    },
    model: {
      value: (_vm.tgl_akhir),
      callback: function($$v) {
        _vm.tgl_akhir = $$v
      },
      expression: "tgl_akhir"
    }
  })], 1)], 1)]), _vm._v(" "), (_vm.jns_laporan == '1' || _vm.jns_laporan == '2') ? _c('div', {
    staticClass: "col-12",
    staticStyle: {
      "height": "300px",
      "max-width": "1400px",
      "overflow-y": "scroll",
      "overflow-x": "scroll"
    }
  }, [(_vm.parse_csv) ? _c('table', {
    staticClass: "table table-bordered table-hover table-sm",
    attrs: {
      "border": "1"
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.parse_header), function(key) {
    return _c('th', {
      class: {
        active: _vm.sortKey == key
      },
      on: {
        "click": function($event) {
          _vm.sortBy(key)
        }
      }
    }, [_vm._v("\n                " + _vm._s(_vm._f("capitalize")(key)) + "\n                "), _c('span', {
      staticClass: "arrow",
      class: _vm.sortOrders[key] > 0 ? 'asc' : 'dsc'
    })])
  }))]), _vm._v(" "), _c('tbody', _vm._l((_vm.parse_csv), function(csv) {
    return _c('tr', _vm._l((_vm.parse_header), function(key) {
      return _c('td', [_vm._v("\n                " + _vm._s(csv[key]) + "\n              ")])
    }))
  }))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('br'), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "title": "Kirim Laporan",
      "disabled": !_vm.isComplete
    },
    on: {
      "click": _vm.swalreport
    }
  }, [_c('i', {
    staticClass: "fa fa-send"
  }), _vm._v(" Kirim")])])])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-441e01ce","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Pengajuan/Upload.vue
// module id = 288
// module chunks = 0